// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__12ryB","subheader":"ReorderModal_subheader__1oVen","listWrap":"ReorderModal_listWrap__11KEs"};